if (!customElements.get('product-content')) {
  customElements.define('product-content', class ProductContent extends HTMLElement {
    constructor() {
      super();
      this.toggleStickyBasedOnDescription(); // ✅ Only handles sticky behavior based on video presence
    }

    // ✅ NEW: Enable/Disable Sticky Add to Cart Based on Video Presence
    toggleStickyBasedOnDescription() {
      const productInformation = document.querySelector('product-information');
      if (!productInformation) return;

      const descriptionBlock = productInformation.querySelector('[data-block-type="description"]');
      if (!descriptionBlock) return;

      const hasVideo = descriptionBlock.querySelector('video') !== null; // ✅ Check if description contains a video

      enquire.register('screen and (min-width: 1001px)', {
        match: () => {
          if (hasVideo) {
            // ✅ If video exists, disable sticky Add to Cart but keep a placeholder for spacing
            productInformation.classList.add('disable-scroll');
            window.removeEventListener('scroll', productInformation.onScrollToolsHandler);
            productInformation.style.position = "static";

            // ✅ Placeholder to keep spacing correct
            let placeholder = document.querySelector('.sticky-placeholder');
            if (!placeholder) {
              placeholder = document.createElement('div');
              placeholder.classList.add('sticky-placeholder');
              productInformation.after(placeholder);
            }
            placeholder.style.height = "80px"; // Adjust to match sticky Add to Cart height
          } else {
            // ✅ If NO video, enable sticky Add to Cart and remove placeholder
            productInformation.classList.remove('disable-scroll');
            window.addEventListener('scroll', productInformation.onScrollToolsHandler);

            const placeholder = document.querySelector('.sticky-placeholder');
            if (placeholder) {
              placeholder.remove();
            }
          }
        }
      });
    }
  });
}
